import { render, staticRenderFns } from "./RuleEditView.vue?vue&type=template&id=1f8e58e4&scoped=true&"
import script from "./RuleEditView.vue?vue&type=script&lang=js&"
export * from "./RuleEditView.vue?vue&type=script&lang=js&"
import style0 from "./RuleEditView.vue?vue&type=style&index=0&id=1f8e58e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8e58e4",
  null
  
)

/* custom blocks */
import block0 from "./RuleEditView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports